import {useContext, useState} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'

import CardAdModalFinancingDetails from './card-ad-modal-financing-details.js'

const LENDER_IMAGE_HEIGHT = 16
const LENDER_IMAGE_HEIGHT_LARGE = 24
const LENDER_IMAGE_WIDTH = 60

const CardAdFinancingInfo = ({adInfo, financingInfo, isVertical = false, seller}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')
  const {FINANCING_PARTNERS, LENDERS_DICTIONARIES} = config.get('financing')

  const getClassName = baseClass =>
    cx(baseClass, {
      isVertical
    })

  const handleModal = state => setIsModalOpen(state)

  const isSantanderPriLender = financingInfo?.lender === FINANCING_PARTNERS.SANTANDER_PRI

  const showEntry = !isSantanderPriLender
  const showFootnoteMark = isSantanderPriLender

  const hasSmallPadding = financingInfo?.lender === FINANCING_PARTNERS.COFIDIS

  if (!financingInfo && !seller) return null

  return (
    <div>
      {showEntry ? (
        <span className={getClassName('mt-CardAd-financingInfoItem')}>
          {financingInfo?.entry !== 0
            ? `*${i18n.t('FINANCING_INFO.ENTRANCE_FEE')}: ${i18n.c(financingInfo?.entry)}`
            : `*${i18n.t('FINANCING_INFO.ENTRACE_FEE_EMPTY')}`}
        </span>
      ) : null}
      <span className={getClassName('mt-CardAd-financingInfoItem')}>
        {showFootnoteMark && `*`}
        {i18n.t('COMMON_N_MONTHS', financingInfo?.terms)}
      </span>
      <span
        aria-haspopup="dialog"
        className={getClassName('mt-CardAd-financingInfoItemUnderline')}
        onClick={() => handleModal(true)}
        role="button"
        tabIndex={0}
      >
        {`${i18n.t(isVertical ? 'FINANCING_INFO.TAE' : 'FINANCING_INFO.TAE_EXAMPLE')} ${i18n.f(
          'percentage',
          financingInfo?.tae.toFixed(2)
        )}`}
      </span>
      <span className={getClassName('mt-CardAd-financingInfoItem')}>{i18n.t('COMMON.WITH')}</span>
      <div className="mt-CardAd-financingInfoLenderImage">
        <AtomImage
          alt={i18n.t(LENDERS_DICTIONARIES[financingInfo?.lender]?.name)}
          src={`${URL_STATICS_IMAGES}common/logos/${financingInfo?.lender}.svg`}
          height={hasSmallPadding ? LENDER_IMAGE_HEIGHT_LARGE : LENDER_IMAGE_HEIGHT}
          width={LENDER_IMAGE_WIDTH}
        />
      </div>
      {isModalOpen && (
        <div className="mt-CardAd-modalFinancingDetails">
          <CardAdModalFinancingDetails adInfo={adInfo} handleModal={handleModal} />
        </div>
      )}
    </div>
  )
}

CardAdFinancingInfo.displayName = 'CardAdFinancingInfo'

CardAdFinancingInfo.propTypes = {
  adInfo: PropTypes.shape({
    adId: PropTypes.string,
    cashPrice: PropTypes.number,
    financedPrice: PropTypes.number
  }),
  financingInfo: PropTypes.object,
  isVertical: PropTypes.bool,
  seller: PropTypes.shape({
    name: PropTypes.string,
    ratings: PropTypes.shape({
      average: PropTypes.number,
      tags: PropTypes.array,
      totalReviews: PropTypes.number
    })
  })
}

export default CardAdFinancingInfo
